import { AsyncPipe, NgFor, NgIf, NgSwitch, NgSwitchCase } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewEncapsulation,
  ViewRef,
} from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { TranslatePipe } from '@spartacus/core';
import { CurrentProductService, ProductDetailOutlets } from '@spartacus/storefront';
import { Observable, Subscription, take } from 'rxjs';
import { ComponentService } from 'src/app/service/component.service';
import { CustomProductService } from 'src/app/service/product/custom-product.service';
import { SnahCountryService, WAREHOUSE } from 'src/app/service/snah/snah-countries.service';
import { ProductLeadTime as Product } from '../../../../model/product.model';
import { NotifyMeComponent } from '../notify-me/notify-me.component';
import { ProductSizeChartComponent } from '../product-size-chart/product-size-chart.component';

@Component({
  selector: 'app-product-stock-info',
  templateUrl: './product-stock-info.component.html',
  styleUrls: ['./product-stock-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.Emulated,
  providers: [AsyncPipe],
  imports: [
    NgIf,
    NgSwitch,
    NgSwitchCase,
    MatIcon,
    NgFor,
    ProductSizeChartComponent,
    NotifyMeComponent,
    AsyncPipe,
    TranslatePipe,
  ],
})
export class ProductStockInfoComponent implements OnInit, OnDestroy, AfterViewInit {
  outlets = ProductDetailOutlets;
  isDiscontinuedSubscription$: Subscription;
  isDiscontinued: boolean;
  showDiv: boolean = false;
  manualAllocationEnabled: boolean = false;

  product$: Observable<Product> = this.currentProductService.getProduct();
  showWarehouseFeature$: Observable<boolean> = this.SnahCountryService.getSnahFeatures(WAREHOUSE);

  constructor(
    protected currentProductService: CurrentProductService,
    protected componentService: ComponentService,
    private cdr: ChangeDetectorRef,
    private SnahCountryService: SnahCountryService,
    private pipeAsync: AsyncPipe,
    private renderer: Renderer2,
    private elRef: ElementRef,
    private customProductService: CustomProductService
  ) {}

  ngOnInit(): void {
    this.isDiscontinuedSubscription$ = this.componentService.isDiscontinued$.subscribe((isDiscontinued) => {
      isDiscontinued ? (this.isDiscontinued = isDiscontinued) : false;
      if (!(this.cdr as ViewRef).destroyed) {
        this.cdr.detectChanges();
      }
    });
    this.customProductService
      .isProductManualAllocationEnabled$()
      .pipe(take(1))
      .subscribe((isEnabled) => {
        this.manualAllocationEnabled = isEnabled;
        this.cdr.detectChanges();
      });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.showDiv = !this.showDiv ? true : false;
      if (!(this.cdr as ViewRef).destroyed) {
        this.cdr.detectChanges();
      }
    }, 500);
  }

  checkSalesRepStockData(salesRepStockData: any, isSnahCountry: boolean) {
    // Cleaning overlay here since this method runs on every product change
    this.removeOverlayClass();
    let finalStocks = [];
    const numbeOfWarehouseDisplay = isSnahCountry ? 10 : 2;
    const stocks = salesRepStockData.slice(0, numbeOfWarehouseDisplay);

    if (stocks.length > 0) {
      if (stocks.every((item: any) => item.stockLevelStatus === 'outOfStock')) {
        finalStocks = isSnahCountry ? stocks : stocks.slice(0, 1);
      } else if (stocks.every((item: any) => item.stockLevelStatus === 'discontinued')) {
        finalStocks = stocks.slice(0, 1);
      } else {
        let status: string = isSnahCountry ? 'discontinued' : 'outOfStock';
        finalStocks = stocks.filter((item: any) => item.stockLevelStatus !== status);
      }
    }
    return finalStocks;
  }

  salesRepStockData(salesRepStockData: any) {
    if (salesRepStockData) {
      if (salesRepStockData.length < 1) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }
  isBoolean(status: boolean | null | undefined): boolean {
    return status === true || status === false;
  }

  checkStockLevel(stockLevel: string, isSnahCountry: boolean): string {
    if (isSnahCountry) {
      return parseInt(stockLevel) > 100 ? '100+' : stockLevel;
    } else {
      return stockLevel;
    }
  }
  addOverlay(product: any, isDiscontinued: boolean) {
    let hasMultipleVariants = false;
    const productStockInfo = document.querySelector('app-product-stock-info');
    if (product.variantMatrix && product.variantMatrix.length > 0) {
      const variantMatrix = product.variantMatrix;

      if (variantMatrix.length > 1) {
        hasMultipleVariants = true;
      } else {
        hasMultipleVariants = this.checkVariantLevels(variantMatrix);
      }
    }
    if ((this.isDiscontinued && !hasMultipleVariants) || isDiscontinued) {
      productStockInfo.classList.add('overlay-error-msg');
    }
  }

  private checkVariantLevels(elements: any[]): boolean {
    if (elements.length > 1) {
      return true;
    }

    for (const element of elements) {
      if (element.elements && element.elements.length > 0) {
        if (this.checkVariantLevels(element.elements)) {
          return true;
        }
      }
    }
  }

  removeOverlayClass(): void {
    const productStockInfo = this.elRef.nativeElement.parentElement.querySelector('app-product-stock-info');
    if (productStockInfo) {
      this.renderer.removeClass(productStockInfo, 'overlay-error-msg');
    }
  }

  ngOnDestroy() {
    this.isDiscontinuedSubscription$?.unsubscribe();
  }
}
